<template>
	<div class="search-form mr-2">
		<b-row align-h="between">
			<b-col cols="7">
				<b-form onsubmit="return false">
					<b-input-group size="sm">
						<b-form-input
							v-model="form.searchKey"
							@keyup.enter="clickQuery"
							type="search"
							placeholder="用户名称/手机号/邮箱/微信号/用户职务搜索..."
							size="sm"
						/>
						<b-input-group-append>
							<b-button-group>
								<b-button-group slot="reference">
									<b-button
										variant="link"
										size="sm"
										class="search-dropdown-button"
										squared
										@click="visible = !visible"
									>
										高级搜索
									</b-button>
									<b-button
										variant="primary"
										size="sm"
										@click="clickQuery"
									>
										<i class="fa fa-search"></i>
									</b-button>
								</b-button-group>
							</b-button-group>
						</b-input-group-append>
						<!-- 头部按钮 -->
						<b-button
							size="sm"
							class="ml-2"
							variant="outline-success"
							@click="openEditPage({ pageType: 'add' })"
							v-allow="'actAdd'"
						>
							新增用户
						</b-button>
						<b-button
							size="sm"
							class="ml-2"
							variant="outline-success"
							@click="actExport()"
							v-allow="'actExport'"
						>
							导出
						</b-button>
					</b-input-group>
				</b-form>
			</b-col>
		</b-row>
		<el-dialog
			title="高级搜索"
			:show-close="true"
			:visible.sync="visible"
			v-el-dialog-drag
			width="680px"
			:close-on-click-modal="false"
		>
			<el-form ref="form" :model="form" label-width="80px">
				<el-row>
					<el-form-item label="用户状态">
						<el-col :span="24">
							<el-checkbox-group v-model="form.userStatusList">
								<el-checkbox label="Y" name="type"
									>有效</el-checkbox
								>
								<el-checkbox label="N" name="type"
									>无效</el-checkbox
								>
								<el-checkbox label="S" name="type"
									>停用</el-checkbox
								>
							</el-checkbox-group>
						</el-col>
					</el-form-item>
					<el-form-item label="姓名">
						<el-col :span="11">
							<el-input
								v-model="form.userName"
								maxlength="100"
								placeholder="请输入用户姓名"
								clearable
								size="small"
							></el-input>
						</el-col>
						<el-col class="line" :span="2">手机</el-col>
						<el-col :span="11">
							<el-input
								v-model="form.userMobileNo"
								maxlength="100"
								placeholder="请输入手机号"
								clearable
								size="small"
							></el-input>
						</el-col>
					</el-form-item>
					<el-form-item label="邮箱">
						<el-col :span="11">
							<el-input
								v-model="form.userEmail"
								maxlength="100"
								placeholder="请输入邮箱"
								clearable
								size="small"
							></el-input>
						</el-col>
						<el-col class="line" :span="2">微信</el-col>
						<el-col :span="11">
							<el-input
								v-model="form.userWechat"
								maxlength="100"
								placeholder="请输入微信账号"
								clearable
								size="small"
							></el-input>
						</el-col>
					</el-form-item>
					<el-form-item label="所属机构">
						<el-col :span="11">
							<org-cascader
								:lastValue.sync="form.orgCode"
								placeholder="请选择所属机构"
							/>
						</el-col>
						<el-col class="line" :span="2">职务</el-col>
						<el-col :span="11">
							<el-input
								v-model="form.userJob"
								maxlength="100"
								placeholder="请输入人员职务"
								clearable
								size="small"
							></el-input>
						</el-col>
					</el-form-item>
					<el-form-item label="修改日期">
						<el-col :span="11">
							<el-date-picker
								v-model="form.modifyDateStart"
								type="date"
								size="small"
								value-format="yyyy-MM-dd"
								placeholder="选择日期"
								style="width: 100%"
							>
							</el-date-picker>
						</el-col>
						<el-col class="line" :span="2">-</el-col>
						<el-col :span="11">
							<el-date-picker
								v-model="form.modifyDateEnd"
								type="date"
								size="small"
								value-format="yyyy-MM-dd"
								placeholder="选择日期"
								style="width: 100%"
							>
							</el-date-picker>
						</el-col>
					</el-form-item>
				</el-row>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="closeDialog"
					>取消查询</el-button
				>
				<el-button size="small" type="warning" @click="reset"
					>重置条件</el-button
				>
				<el-button size="small" type="primary" @click="clickQuery"
					>数据检索</el-button
				>
			</span>
		</el-dialog>
	</div>
</template>

<script>
export default {
	data() {
		return {
			visible: false,
			form: {
				searchKey: '',
				userStatusList: ['Y'],
			},
		}
	},
	created() {
		this.reset()

		let _this = this
		this.$eventBus.$on('sysUserTableReload', function() {
			_this.clickQuery()
		})
	},
	methods: {
		openEditPage({ pageType, params }) {
			this.$router.push({
				name: 'system-sysuser-detail',
				params: { ...params, pageType },
			})
		},
		actExport() {
			let url = '/sys/user/export'
			let fileName = '系统用户信息导出'
			this.$api.globalExportData(url, this.form, fileName)
		},
		onReset() {
			this.form = {
				searchKey: '',
				userStatusList: ['Y'],
			}
			this.query()
		},
		clickQuery() {
			this.$emit('reset')
			this.query()
		},
		query() {
			this.$emit('submit', this.form)
			this.visible = false
		},
		reset() {
			this.$emit('reset')
			this.onReset()
		},
		closeDialog() {
			this.visible = false
		},
	},
}
</script>
<style lang="scss" scoped>
.el-form-item {
	margin-bottom: 0px;
}
.line {
	text-align: center;
}
</style>
